import React from 'react';
import SectionBundleReceiptEntry from '../SectionBundleReceiptEntry';

const YarnBundleReceiptEntry = () => {
  return (
    <SectionBundleReceiptEntry
      sectionName="Yarn"
      sectionDisplayName="Yarn Section"
      backRoute="/sections/yarn"
    />
  );
};

export default YarnBundleReceiptEntry;
